export const noOpAbortable = {
    abort: () => {
        /* noop */
    }
};
